import React, { useMemo } from 'react';
import { Select } from '../Select/Select';
import { Box, Button } from '@mui/material';
import { Switch } from '../Switch/Switch';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ViewSelectorContainer from '../Maquette/ViewSelectorContainer';

export function VisiteOptions({
  pieces,
  currentScene,
  handleChangePiece,
  handlePrevPiece,
  handleNextPiece,
  hasSwitchDeco,
  checkedSwitchDeco,
  handleChangeSwitchDeco,
}) {
  const piecesForSelect = useMemo(() => {
    if (!pieces) return [];
    return pieces.reduce((acc, piece) => {
      return [...acc, { value: piece.slug, label: piece.name }];
    }, []);
  }, [pieces]);

  const sx = {
    containerBorder: {
      borderRightStyle: 'dotted',
      borderRightWidth: '1px',
      borderRightColor: 'grey.500',
      paddingInline: '8px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    button: {
      minWidth: 'unset',
      padding: '6px',
      width: '34px',
      height: '34px',
      fontSize: '1rem',
    },
  };

  return (
    <ViewSelectorContainer
      orientation="horizontal"
      sx={{
        alignItems: 'center',
        paddingBlock: '6px',
        '> div:last-of-type': {
          border: 'none !important',
        },
      }}
    >
      <Box sx={sx.containerBorder}>
        <Button
          variant="outlined"
          onClick={handlePrevPiece}
          sx={{ ...sx.button }}
        >
          <KeyboardArrowLeftIcon />
        </Button>

        <Select
          options={piecesForSelect}
          value={currentScene?.slug}
          handleChange={handleChangePiece}
        />

        <Button
          variant="outlined"
          onClick={handleNextPiece}
          sx={{ ...sx.button }}
        >
          <KeyboardArrowRightIcon />
        </Button>
      </Box>

      {hasSwitchDeco ? (
        <Box sx={sx.containerBorder}>
          <Switch
            label={checkedSwitchDeco ? 'Déco' : 'Nu'}
            checked={checkedSwitchDeco}
            handleChange={handleChangeSwitchDeco}
          />
        </Box>
      ) : null}
    </ViewSelectorContainer>
  );
}
